import type {ReactElement} from 'react';
import {EventWizardImageVideoSection} from './components/event-wizard-image-video-section/event-wizard-image-video-section';
import {EventWizardImageVideoTile} from './components/event-wizard-image-video-tile/event-wizard-image-video-tile';
import type {EventWizardImageVideoProps} from './event-wizard-image-video.types';
import {EventWizardImageVideoVariant} from './event-wizard-image-video.types';

export function EventWizardImageVideo({variant = EventWizardImageVideoVariant.SECTION}: EventWizardImageVideoProps): ReactElement {
  if (variant === EventWizardImageVideoVariant.TILE) {
    return <EventWizardImageVideoTile />;
  }
  return <EventWizardImageVideoSection />;
}
